const mime = require("mime-types");

global.indexedDB = global.indexedDB || global.mozIndexedDB || global.webkitIndexedDB || global.msIndexedDB;
global.IDBTransaction = global.IDBTransaction || global.webkitIDBTransaction || global.msIDBTransaction;
global.IDBKeyRange = global.IDBKeyRange || global.webkitIDBKeyRange || global.msIDBKeyRange;

var db
var dbconnect = global.indexedDB ? global.indexedDB.open("cache", 1) : null
var MAX_SIZE = 1048576

if (dbconnect) {
  dbconnect.onupgradeneeded = event => {
    db = event.target.result
    db.createObjectStore("files", { keyPath: "uid" })
  }
  dbconnect.onsuccess = event => db = dbconnect.result
  dbconnect.onerror = event => console.error(event.target.errorCode)
}

function updateDB(data) {
  return new Promise((resolve, reject) => {
    let tr = db.transaction("files", "readwrite")
    tr.onerror = event => reject("transaction error")
    let obj = tr.objectStore("files")
    obj.onerror = event => reject("objectStore error")
    let req = obj.put(data);
    req.onerror = event => reject("request error")
    req.onsuccess = event => resolve()
  })
}

function selectDB(uid) {
  return new Promise((resolve, reject) => {
    let tr = db.transaction("files", "readonly")
    tr.onerror = event => reject("transaction error")
    let obj = tr.objectStore("files")
    obj.onerror = event => reject("objectStore error")
    let req = obj.get(uid);
    req.onsuccess = function () {
      if (req.result) resolve(req.result);
      else reject("not found")
    }
    req.onerror = err => reject(err)
  });
}

const storeFile = {
  url(uid, store = global.store.getState()) {
    const { simtopy } = store
    return uid in simtopy.filesURL ? simtopy.filesURL[uid] : null
  },
  timestamp(uid, store = global.store.getState()) {
    const { state } = store
    return state.file && state.file[uid] ? state.file[uid] : "notimestamp"
  },
  meta(uid, store = global.store.getState()) {
    return store.list.file ? store.list.file[uid] : {}
  }
}

async function getDbFile(meta, uid) {
  if (meta && "size" in meta) {
    if (meta.size <= MAX_SIZE) return selectDB(uid)
    else return Promise.reject(`file ${uid} size too heavy`)
  } else return Promise.reject(`no meta on file ${uid}`)
}

const fetchFile = (uid, mode = "socket") => {
  const api = require("api")
  if (mode === "socket") {
    if (global.socket && global.socket.connected) {
      return api.file.socketRead(uid)
    }
  }
  return api.file.httpRead(uid)
}

async function getFile(uid, timestamp) {
  if (uid) {
    let file;
    const store = global.store.getState()
    let meta = storeFile.meta(uid, store)
    timestamp = storeFile.timestamp(uid, store)
    try {
      file = storeFile.url(uid, store)
      if (!file) file = await getDbFile(meta, uid)
      if (file && timestamp && file.timestamp === timestamp) {
        return { ...meta, ...file, data: file.url || file.data }
      } else throw Error(`file ${uid} must be fetched`)
    } catch (err) {
      if (meta) file = await fetchFile(uid, "socket")
      else file = await fetchFile(uid)
      file = await setFile(uid, file, timestamp)
      if (!file) return Promise.reject(err)
      else return { ...meta, timestamp, data: file }
    }
  } else return Promise.reject("getFile: uid is missing");
}

const getBinary = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = event => resolve(event.target.result);
  reader.onerror = reject;
  reader.readAsDataURL(file);
});

async function setFile(uid, file, timestamp) {
  let store = global.store.getState()
  timestamp = storeFile.timestamp(uid, store)
  const url = URL.createObjectURL(file)
  if (file.size <= MAX_SIZE) {
    let data = await getBinary(file);
    let meta = storeFile.meta(uid, store) || {}
    let ext = meta.ext || mime.extension(file.type)
    updateDB({
      uid,
      data,
      ext,
      name: meta.name || file.name,
      type: ext ? mime.lookup(ext) : file.type,
      size: meta.size || file.size,
      timestamp
    }, file);
  }
  global.store.dispatch({
    type: "SET_FILE_URL",
    uid,
    url,
    timestamp
  })
  return url
}

function b64toBlob(file) {
  const contentType = mime.lookup(file.ext)
  const byteString = atob(file.data.split(',')[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ia], { type: contentType });
}

async function fileToBlob(file) {
  try {
    // from file uid
    if (typeof file === "string") file = await getFile(file)
    let { data } = file || {}
    // Blob type
    if (data instanceof Blob) return data
    // File type
    if (data instanceof File) data = await getBinary(file)
    // reject on any else type but string
    if (typeof data !== "string") {
      return Promise.reject(`unhandled file.data type ${JSON.stringify(data, null, 2)}`)
    }
    // base64 type
    if (data.slice(0, 5) === "data:" && data.includes("base64")) {
      return b64toBlob(file)
    }
    // objectURL blob type (browser cache url)
    if (data.slice(0, 5) === "blob:") {
      return fetch(data).then(r => r.blob())
    }
    // reject for unknown string format
    return Promise.reject("unhandled file.data string", data)
  } catch (err) {
    return Promise.reject(err)
  }
}

module.exports = {
  getFile,
  setFile,
  async readFile(file) {
    try {
      const blob = await fileToBlob(file)
      const str = await new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = e => resolve(reader.result)
        reader.onerror = reject
        reader.readAsText(blob)
      })
      return str
    } catch (err) {
      console.error(`readFile failed ${JSON.stringify(file, null, 2)}`)
      return Promise.reject(err)
    }
  },
  async downloadFile(uid) {
    let file = await getFile(uid);
    let dl = document.createElement('a');
    dl.setAttribute('href', file.data);
    let ext = file.ext && file.ext.split(".").pop()
    dl.setAttribute('download', ext ? `${file.name}.${ext}` : file.name);
    dl.style.display = 'none';
    document.body.appendChild(dl);
    dl.click();
    document.body.removeChild(dl);
  },
  removeFile(uid) {
    global.store.dispatch({
      type: "DEL_FILE_URL",
      uid
    })
    // TODO: remove from indexDB
  }
}
